import { useAuth } from '../../context/AuthContext';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

export default function BillingRequired() {
  const { user, userProfile, org, planStatus, role, suspended } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleManageBilling = async () => {
    setError('');
    setLoading(true);
    try {
      const createPortal = httpsCallable(functions, 'createCustomerPortalSession');
      const result = await createPortal({ baseUrl: window.location.origin });
      const url = result.data?.url;
      if (!url) throw new Error('No portal URL returned.');
      window.location.href = url;
    } catch (err) {
      console.error('Portal session failed', err);
      setError(err.message || 'Could not open billing portal. Please try again or contact support.');
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    await signOut(auth);
    window.location.href = '/login';
  };

  const statusMessage = (() => {
    if (suspended) return 'Access to your organisation has been suspended by Agriware. Please contact Agriware to restore access.';
    if (planStatus === 'past_due') return 'Your last payment failed. Please update your billing details to restore access.';
    if (planStatus === 'canceled') return 'Your subscription has been cancelled. Reactivate it to restore access.';
    if (planStatus === 'unpaid') return 'Your subscription is unpaid. Please update your billing details.';
    if (planStatus === 'incomplete') return 'Your subscription payment did not complete. Please try again.';
    return 'Your organisation does not have an active subscription.';
  })();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 480, background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: 36 }}>
        <h1 style={{ fontSize: 20, fontWeight: 500, margin: '0 0 8px' }}>{suspended ? 'Account suspended' : 'Subscription required'}</h1>
        <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.6, margin: '0 0 20px' }}>
          {statusMessage}
        </p>

        {org && (
          <div style={{ padding: 14, background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius-md)', marginBottom: 20 }}>
            <div style={{ fontSize: 10, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Organisation</div>
            <div style={{ fontSize: 14 }}>{org.name}</div>
            <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 6 }}>
              Status: {planStatus || 'no subscription'}
            </div>
          </div>
        )}

        {error && (
          <div style={{ marginBottom: 16, padding: '10px 12px', background: 'var(--color-danger-light)', color: 'var(--color-danger)', borderRadius: 'var(--radius-sm)', fontSize: 12 }}>
            {error}
          </div>
        )}

        {suspended ? null : role === 'org_admin' ? (
          <>
            <button
              onClick={handleManageBilling}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px 16px',
                background: 'var(--color-brand)',
                color: '#fff',
                border: 'none',
                borderRadius: 'var(--radius-md)',
                fontSize: 13,
                fontWeight: 500,
                cursor: loading ? 'default' : 'pointer',
                opacity: loading ? 0.6 : 1,
                marginBottom: 12,
              }}
            >
              {loading ? 'Opening billing portal…' : 'Manage billing'}
            </button>
            <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', lineHeight: 1.6, marginBottom: 16 }}>
              You'll be taken to a secure billing portal hosted by Stripe where you can update your payment method, view invoices, or cancel your subscription.
            </div>
          </>
        ) : (
          <div style={{ padding: 14, background: 'var(--color-warning-light, rgba(255,180,0,0.1))', borderRadius: 'var(--radius-md)', marginBottom: 20, fontSize: 12, lineHeight: 1.6, color: 'var(--color-text-secondary)' }}>
            Only your organisation's admin can manage billing. Please contact them to restore access.
          </div>
        )}

        <button
          onClick={handleSignOut}
          style={{
            width: '100%',
            padding: '10px 16px',
            background: 'transparent',
            color: 'var(--color-text-secondary)',
            border: '0.5px solid var(--color-border-light)',
            borderRadius: 'var(--radius-md)',
            fontSize: 12,
            cursor: 'pointer',
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
